import { assign, unset } from 'icepick';
import { chainUnsafe as chain } from '@atlassian/jira-common-icepick/src/utils/unsafe/index.tsx';
import { SPRINT } from '../../../../model/constants';
import { SET_APP_DATA, type SetAppDataAction } from '../../../actions/app';
import {
	SPRINT_CREATE_REQUEST,
	SPRINT_CREATE_SUCCESS,
	type SprintCreateRequestAction,
	type SprintCreateSuccessAction,
} from '../../../actions/sprints/create';
import {
	SPRINT_DELETE_REQUEST,
	type SprintDeleteRequestAction,
} from '../../../actions/sprints/delete';
import { type EditSprintRequestAction, EDIT_SPRINT_REQUEST } from '../../../actions/sprints/edit';
import type { CardListEntityState } from './types';

type Action =
	| SetAppDataAction
	| SprintCreateRequestAction
	| SprintCreateSuccessAction
	| SprintDeleteRequestAction
	| EditSprintRequestAction;

const defaultState: CardListEntityState = {};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: CardListEntityState = defaultState, action: Action): CardListEntityState => {
	switch (action.type) {
		case SET_APP_DATA:
			return action.payload.entities.cardList;
		case SPRINT_CREATE_REQUEST:
			return assign(state, {
				[action.payload.temporaryCardListId]: {
					id: String(action.payload.temporaryCardListId),
					name: 'Sprint',
					type: SPRINT,
					issueListKey: null,
					isOptimistic: true,
					sprintData: {
						goal: '',
						startDate: '',
						endDate: '',
						daysRemaining: 0,
						state: 'FUTURE',
						canUpdateSprint: true,
					},
				},
			});
		case SPRINT_CREATE_SUCCESS:
			return chain(state)
				.set(action.payload.sprint.id, action.payload.sprint)
				.unset(action.payload.temporaryCardListId)
				.value();

		case SPRINT_DELETE_REQUEST:
			return unset(state, action.payload.sprintId);

		case EDIT_SPRINT_REQUEST:
			return chain(state)
				.setIn([String(action.payload.id), 'name'], action.payload.name)
				.setIn([String(action.payload.id), 'sprintData', 'goal'], action.payload.goal)
				.setIn([String(action.payload.id), 'sprintData', 'startDate'], action.payload.startDate)
				.setIn([String(action.payload.id), 'sprintData', 'endDate'], action.payload.endDate)
				.value();
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
